import { render } from "./addIntensityModal.vue?vue&type=template&id=6570bd6f"
import script from "./addIntensityModal.vue?vue&type=script&lang=js"
export * from "./addIntensityModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__